var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("header", [_c("main-header")], 1),
    _c("main", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "wraper" },
        [
          [
            _c(
              "div",
              { staticClass: "modal" },
              [
                _c(
                  "el-row",
                  { staticClass: "spacing" },
                  [
                    _c(
                      "el-row",
                      { staticClass: "box" },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: "Processo:",
                                content: _vm.numeroProcesso
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: "Data de cadastro:",
                                content: this.dataCadastro
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          [
                            _c("app-display", {
                              attrs: {
                                label: "Tipo de cadastro:",
                                content: _vm.tipo
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.isCredenciado
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-tabs",
                          {
                            attrs: { type: "border-card" },
                            model: {
                              value: _vm.activeTab,
                              callback: function($$v) {
                                _vm.activeTab = $$v
                              },
                              expression: "activeTab"
                            }
                          },
                          _vm._l(
                            _vm.configModalVisualizarProcessoCredenciado,
                            function(item) {
                              return _c(
                                "el-tab-pane",
                                {
                                  key: item.name,
                                  attrs: { label: item.label, name: item.name }
                                },
                                [
                                  _vm.activeTab === item.name
                                    ? _c(item.component, {
                                        tag: "component",
                                        attrs: {
                                          showBtnSegundaVia: false,
                                          numeroProcesso: _vm.numeroProcesso,
                                          idProcesso: _vm.idProcesso,
                                          protocolo: _vm.protocolo
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }
                          ),
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "el-tabs",
                          {
                            attrs: { type: "border-card" },
                            model: {
                              value: _vm.activeTab,
                              callback: function($$v) {
                                _vm.activeTab = $$v
                              },
                              expression: "activeTab"
                            }
                          },
                          _vm._l(_vm.configModalVisualizarProcesso, function(
                            item
                          ) {
                            return _c(
                              "el-tab-pane",
                              {
                                key: item.name,
                                attrs: { label: item.label, name: item.name }
                              },
                              [
                                _vm.activeTab === item.name
                                  ? _c(item.component, {
                                      tag: "component",
                                      attrs: {
                                        showBtnSegundaVia: false,
                                        numeroProcesso: _vm.numeroProcesso,
                                        idProcesso: _vm.idProcesso,
                                        protocolo: _vm.protocolo,
                                        tipoProcesso: _vm.codigoTipo,
                                        bpmnXml: _vm.xml,
                                        fluxos: _vm.fluxos
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
              ],
              1
            ),
            !_vm.isCredenciado
              ? _c(
                  "div",
                  { staticClass: "download-button" },
                  [
                    (_vm.activeTab !== "TAB_PROCESSO" &&
                      _vm.tiposPermitidos.includes(_vm.tipo)) ||
                    _vm.activeTab === "TAB_HISTORICO"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "btn-baixar-pdf",
                            attrs: { type: "default" },
                            on: {
                              click:
                                _vm.configModalVisualizarProcesso[_vm.activeTab]
                                  .actionButton
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas",
                              class:
                                _vm.configModalVisualizarProcesso[_vm.activeTab]
                                  .classIcon
                            }),
                            _c("b", { staticClass: "margin-left" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.configModalVisualizarProcesso[
                                    _vm.activeTab
                                  ].textButton
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    (_vm.activeTab !== "TAB_PROCESSO" &&
                      _vm.tiposPermitidos.includes(_vm.tipo)) ||
                    _vm.activeTab === "TAB_HISTORICO"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "btn-baixar-pdf",
                            attrs: { type: "default" },
                            on: {
                              click:
                                _vm.configModalVisualizarProcesso[_vm.activeTab]
                                  .actionButtonZip
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas",
                              class:
                                _vm.configModalVisualizarProcesso[_vm.activeTab]
                                  .classIconZip
                            }),
                            _c("b", { staticClass: "margin-left" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.configModalVisualizarProcesso[
                                    _vm.activeTab
                                  ].textButtonZip
                                )
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-089bab06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089bab06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/VisualizarProcesso.vue
// module id = null
// module chunks = 